<template>
  <div ref="filterModalWrapper">
    <div class="imot" :class="'layout-' + layoutSize + ' ' + textColorClass" ref="filterModal">
      <section class="filters" :class="{ '-showFilters': filterModalActive }" v-body-scroll-lock="filterModalActive">
        <div class="primaryFilters">
          <div class="primaryFilters__heading">
            <template v-if="layoutSize === 'lg' || layoutSize === 'xl'">
              <h1 class="primaryFilters__title">{{ $t('filters.title') }}</h1>
            </template>
            <template v-else>
              <h1 class="primaryFilters__title">{{ $t('filters.modalTitle') }}</h1>
              <button v-on:click="hideFilterModal" class="primaryFilters__closeButton button button--close"></button>
            </template>
          </div>
          <!-- .primaryFilters__heading -->
          <select class="primaryFilters__select primaryFilters__select--brand form-select" @change="updateBrand($event)">
            <option value="">{{ $t('filters.allBrands') }}</option>
            <option v-for="brand in brands" :key="brand.id" :selected="brand.id === selectedBrand" :value="brand.id">
              {{ brand.label }}
            </option>
          </select>
          <select
            :disabled="selectedBrand === ''"
            class="primaryFilters__select primaryFilters__select--model form-select"
            @change="updateModel($event)"
          >
            <option value="">{{ $t('filters.allModels') }}</option>
            <option v-for="model in models" :key="model.id" :selected="model.id === selectedModel" :value="model.id">
              {{ model.label }}
            </option>
          </select>

          <div class="primaryFilters__option">
            <span class="primaryFilters__optionTitle">{{ $t('vehicle.price') }}</span>
            <span class="primaryFilters__optionValue"> {{ selectedPrice.min | toEUR }} - {{ selectedPrice.max | toEUR }} </span>
            <!-- .primaryFilters__optionValue -->
            <div class="primaryFilters__optionSlider rangeSlider">
              <veeno
                connect
                :key="resetSliders"
                :handles="[selectedPrice.min, selectedPrice.max]"
                :range="{
                  min: primaryOptions.price.min,
                  max: primaryOptions.price.max,
                }"
                :step="1000"
                @update="priceSliderChange"
              />
            </div>
            <!-- .primaryFilters__optionSlider -->
          </div>
          <!-- .primaryFilters__option -->

          <div class="primaryFilters__option">
            <span class="primaryFilters__optionTitle">{{ $t('vehicle.mileage') }}</span>
            <span class="primaryFilters__optionValue">
              {{ selectedMileage.min | thousandSeparated }} - {{ selectedMileage.max | thousandSeparated }} {{ $t('vehicle.mileageUnit') }}
            </span>
            <!-- .primaryFilters__optionValue -->
            <div class="primaryFilters__optionSlider rangeSlider">
              <veeno
                connect
                :key="resetSliders"
                :handles="[selectedMileage.min, selectedMileage.max]"
                :range="{
                  min: primaryOptions.mileage.min,
                  max: primaryOptions.mileage.max,
                }"
                :step="5000"
                @update="mileageSliderChange"
              />
            </div>
            <!-- .primaryFilters__optionSlider -->
          </div>
          <!-- .primaryFilters__option -->
        </div>
        <!-- .primaryFilters -->

        <!-- <div class="CarSelexyFilter">
          <div class="form-checkbox form-checkbox__carselexy">
            <input
              id="CarSelexyFilter"
              type="checkbox"
              :checked="isCarSelexy"
              class="filterItem__optionCheckbox form-checkbox__input"
              @change="updateCarSelexy($event)"
            />
            <label class="filterItem__optionLabel form-checkbox__label" for="CarSelexyFilter">CarSelexy</label>
          </div>
        </div> -->

        <div class="optionFilters">
          <Collapse v-if="hasCarSelexy" heading="CarSelexy" :isOpen="true">
            <ul class="filterItem__options">
              <li class="filterItem__option">
                <div class="form-checkbox">
                  <input
                    class="filterItem__optionCheckbox form-checkbox__input"
                    id="CarSelexyFilter"
                    type="checkbox"
                    :checked="isCarSelexy"
                    @change="updateCarSelexy($event)"
                  />
                  <label class="filterItem__optionLabel form-checkbox__label" for="CarSelexyFilter">CarSelexy</label>
                </div>
              </li>
            </ul>
          </Collapse>
          <Collapse v-for="filterCat in filterData.otherOptions" v-bind:key="filterCat.id" :heading="$t('vehicle.' + filterCat.id)">
            <ul class="filterItem__options">
              <li class="filterItem__option" v-for="filterOption in filterCat.options" v-bind:key="filterOption.id">
                <div class="form-checkbox">
                  <input
                    class="filterItem__optionCheckbox form-checkbox__input"
                    :id="filterCat.id + '_' + filterOption.id"
                    type="checkbox"
                    :checked="isOptionChecked(filterCat.id, filterOption.id)"
                    @change="updateOption(filterCat.id, filterOption.id, $event)"
                  />
                  <label class="filterItem__optionLabel form-checkbox__label" :for="filterCat.id + '_' + filterOption.id">{{
                    filterOption.label
                  }}</label>
                </div>
                <!-- .form-checkbox -->
              </li>
            </ul>
          </Collapse>
          <!-- Collapse -->
        </div>
        <!-- .optionFilters -->

        <div class="filters__footer">
          <button v-on:click="hideFilterModal" class="filters__footer__button button button--primary button--full">
            {{ $t('filters.modalButton') }} ({{ numberOfResults }})
          </button>
        </div>
        <!-- .filters__footer -->
      </section>
    </div>
  </div>
</template>

<script>
import veeno from 'veeno'
import Collapse from '@/components/Collapse'
import 'nouislider/distribute/nouislider.min.css'

export default {
  name: 'filters',
  components: {
    veeno,
    Collapse,
  },
  computed: {
    filterModalActive: function () {
      return this.$store.state.filters.filterModalActive
    },
    filterData: function () {
      return this.$store.getters['filters/all']
    },
    primaryOptions: function () {
      return this.$store.getters['filters/primaryOptions']
    },
    brands: function () {
      return this.$store.getters['filters/brands']
    },
    models: function () {
      return this.$store.getters['filters/models']
    },
    selectedMileage: function () {
      return this.$store.state.filters.selectedMileage
    },
    selectedPrice: function () {
      return this.$store.state.filters.selectedPrice
    },
    selectedBrand: function () {
      return this.$store.state.filters.selectedBrand
    },
    selectedModel: function () {
      return this.$store.state.filters.selectedModel
    },
    isCarSelexy: function () {
      return this.$store.state.filters.isCarselexy
    },
    hasCarSelexy: function () {
      return this.$store.getters['vehicles/hasCarSelexy']
    },
    resetSliders: function () {
      return this.$store.state.filters.resetSliders
    },
    numberOfResults: function () {
      return this.$store.getters['vehicles/filtered'].length
    },
    layoutSize: function () {
      return this.$store.state.layout.size
    },
    textColorClass: function () {
      return this.$store.state.settings.general !== null ? '-mainTextColor-' + this.$store.state.settings.general.mainTextColor : ''
    },
  },
  watch: {
    filterModalActive(isModalActive) {
      if (isModalActive === true) {
        this.$nextTick(function () {
          const modalEl = this.$refs.filterModal
          modalEl.parentNode.removeChild(modalEl)
          document.body.appendChild(modalEl)
        })
      } else {
        this.$nextTick(function () {
          const modalEl = this.$refs.filterModal
          modalEl.parentNode.removeChild(modalEl)
          this.$refs.filterModalWrapper.appendChild(modalEl)
        })
      }
    },
    layoutSize(newValue) {
      if (newValue === 'lg' || newValue === 'xl') {
        this.hideFilterModal()
      }
    },
  },
  methods: {
    updateOption(catId, optionId, e) {
      const checked = e.target.checked
      this.$store.commit('filters/updateOption', {
        catId: catId,
        optionId: optionId,
        checked: checked,
      })

      if (this.$store.state.search.searchPhrase !== '' && !this.$store.state.search.searchInSelection) {
        this.$store.commit('search/searchInSelection', true)
      }
    },
    mileageSliderChange(event) {
      const mileageMin = event.values[0]
      const mileageMax = event.values[1]
      this.$store.commit('filters/updateMileage', {
        min: mileageMin,
        max: mileageMax,
      })
    },
    priceSliderChange(event) {
      const priceMin = event.values[0]
      const priceMax = event.values[1]
      this.$store.commit('filters/updatePrice', {
        min: priceMin,
        max: priceMax,
      })
    },
    updateBrand(event) {
      const brand = event.target.value
      this.$store.commit('filters/updateBrand', brand)
      this.$store.commit('search/searchInSelection', true)
    },
    updateModel(event) {
      const model = event.target.value
      this.$store.commit('filters/updateModel', model)
      this.$store.commit('search/searchInSelection', true)
    },
    updateCarSelexy(event) {
      const value = this.isCarSelexy ? false : true
      this.$store.commit('filters/updateCarSelexy', value)
      // this.$store.commit('search/searchInSelection', true)
    },
    isOptionChecked(catId, optionId) {
      const selectedOptions = this.$store.state.filters.selectedOptions
      return catId in selectedOptions && selectedOptions[catId].includes(optionId)
    },
    hideFilterModal() {
      this.$store.commit('filters/updateFilterModal', false)
    },
  },
}
</script>
